import { Type } from "types/type"
import styles from '../styles/general.module.scss'
export const joinClassnames = (className: any[]) => {
  return className.filter((e) => !!e).join(' ')
}
export const getTextColor = (type?: Type) => {
  switch (type) {
    case Type.t1:
      return styles.c1
    case Type.t2:
      return styles.c2
    case Type.t3:
      return styles.c3
    case Type.t4:
      return styles.c4
    case Type.t5:
      return styles.c5
    case Type.t6:
      return styles.c6
    case Type.t7:
      return styles.c7
    case Type.t8:
      return styles.c8
    case Type.t9:
      return styles.c9
    case Type.t10:
      return styles.c10
    case Type.t11:
      return styles.c11
    case Type.t12:
      return styles.c12
    case Type.t13:
      return styles.c13
    case Type.t14:
      return styles.c14
    case Type.light:
      return styles.cLight
    case Type.dark:
      return styles.cDark
    case Type.white:
      return styles.cWhite
    case Type.danger:
      return styles.cDanger
    case Type.success:
      return styles.cSuccess
    case Type.warning:
      return styles.cWarning
    case Type.info:
      return styles.cInfo
    case Type.primary:
      return styles.cPrimary
    case Type.secondary:
      return styles.cSecondary
    case Type.tertiary:
      return styles.cTertiary
    default:
      return ''
  }
}